import { initializeApp } from "firebase/app";
import { getFirestore, serverTimestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// ✅ Correct config for your Firebase project
const firebaseConfig = {
  apiKey: "AIzaSyDu0LJljuW64PwQcg6VmoF1hiPgaN5yXKQ",
  authDomain: "cll-dashboard-93e97.firebaseapp.com",
  projectId: "cll-dashboard-93e97",
  storageBucket: "cll-dashboard-93e97.firebasestorage.app", // ✅ correct for new format
  messagingSenderId: "768896640515",
  appId: "1:768896640515:web:5ae609202f446dfc69d036",
  measurementId: "G-258VBHWHB3"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);


export const auth = getAuth(app);
export const storage = getStorage(app);
export const nowTs = serverTimestamp;
